import { render } from "./UserUpdate.vue?vue&type=template&id=126f953a&scoped=true&ts=true"
import script from "./UserUpdate.vue?vue&type=script&lang=ts"
export * from "./UserUpdate.vue?vue&type=script&lang=ts"

import "./UserUpdate.vue?vue&type=style&index=0&id=126f953a&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126f953a"]])

export default __exports__